/*
 * @Description: 导入设置
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

export default {
  导入设置: 'import settings',
  名称: 'name',
  类型: 'type',
  文件名称: 'file name',
  请输入文件名称: 'Please enter the file name',
  提示文本: 'Tooltip',
  请输入提示文本: 'Please enter the prompt text',
  资源库: 'Resource Library',
  请输入搜索内容: 'Please enter search content',
  关联对象: 'Association',
  请选择关联对象: 'Please select the associated object',
  请选择关联主键: 'Please select the associated primary key',
  关联主键: 'Associate Primary Key',
  系统字段: 'System Fields',
  是否必填: 'Is it mandatory to fill in',
  '请补充基本信息！': 'Please provide basic information!',
  '该对象已关联，不能重复关联！': 'The object is already associated and cannot be duplicated!'
};
